// 链接
export default process.env.NODE_ENV === "development"
  ? "http://jw.098iot.com/"
  : "";
